export type MediaOption = "up" | "down" | "only";
export interface MediaQueryProps {
    option: MediaOption;
    first: boolean;
    last: boolean;
    min: number;
    max: number;
}

export const getMediaQuery = ({ option, first, last, min, max }: MediaQueryProps) => {
    const minWidth = `(min-width: ${min}px)`;
    const maxWidth = `(max-width: ${max}px)`;

    if (option === "up") {
        return !first ? `@media ${minWidth}` : null;
    }

    if (option === "down") {
        return !last ? `@media ${maxWidth}` : null;
    }

    if (option === "only") {
        if (first) {
            return `@media ${maxWidth}`;
        }

        if (last) {
            return `@media ${minWidth}`;
        }

        return `@media ${minWidth} and ${maxWidth}`;
    }

    return null;
};

export const getValueMediaQuery = (value: number, option: MediaOption) => {
    return getMediaQuery({
        option,
        first: false,
        last: false,
        min: value,
        max: value,
    });
};

export const getBreakpointMediaQuery = (
    key: string,
    option: MediaOption,
    breakpoints: { keys: string[]; values: number[] },
    mediaQueryProps: Partial<MediaQueryProps> = {},
) => {
    const { keys, values } = breakpoints;
    const index = keys.indexOf(key);

    if (index < 0) {
        return null;
    }

    return getMediaQuery({
        option,
        first: index === 0,
        last: index === values.length - 1,
        min: values[index],
        max: values[index + 1] - 1,
        ...mediaQueryProps,
    });
};
